import React, { useState, useEffect, useCallback } from 'react';
import { Link, withRouter, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { AppBar, Toolbar, IconButton, Tooltip, Badge } from '@material-ui/core';

import ExitToApp from '@material-ui/icons/ExitToApp';
import HeadsetMic from '@material-ui/icons/HeadsetMic';
import FolderShared from '@material-ui/icons/FolderShared';
import AttachMoney from '@material-ui/icons/AttachMoney';
import SupervisedUserCircle from '@material-ui/icons/SupervisedUserCircle';
import AssessmentIcon from '@material-ui/icons/Assessment';
import CampaignIcon from '@mui/icons-material/Campaign';
import MessageIcon from '@material-ui/icons/Message';

import { useSnackbar } from 'notistack';

import {
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  MINI_DRAWER,
} from 'constants/ActionTypes';

import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

import { setDrawerType } from 'actions/Setting';

import SearchBox from 'components/SearchBox';

import { setDarkTheme } from 'actions/index';
import { userSignOut } from 'actions/Auth';
import api from 'services/api';
import { getHashEmpresa } from 'util/cobUtils';
import { getControleDeAcesso } from 'util/AuthUtils';
import DialogDetalhesMensagem from 'components/DialogDetalhesMensagem';

const MSG_DROPDOWN_MENU_STYLE = {
  position: 'absolute',
  top: 60,
  right: 0,
  zIndex: 1500,
  minWidth: 340,
  maxHeight: 450,
  overflowY: 'auto',
  background: '#fff',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  borderRadius: 8,
  padding: 8,
  transformOrigin: 'top right',
  opacity: 1,
  transform: 'translateY(0) scale(1)',
  transition: 'opacity 220ms ease, transform 220ms ease',
  pointerEvents: 'auto',
};

const MSG_DROPDOWN_ITEM_STYLE = {
  borderBottom: '1px solid #eee',
  padding: 16,
  background: '#f7f7f7',
  borderRadius: 6,
  marginBottom: 6,
  transition: 'background 0.2s',
  cursor: 'pointer',
};

const MSG_DROPDOWN_ITEM_HOVER_STYLE = {
  background: '#e8f4fd',
};

const MSG_ITEM_DE_STYLE = {
  fontSize: 13,
  fontWeight: 500,
  color: '#222',
  marginBottom: 4,
};

const MSG_ITEM_SUBJECT_STYLE = {
  fontSize: 13,
  color: '#333',
  marginBottom: 4,
};

const MSG_ITEM_BODY_STYLE = {
  fontSize: 13,
  color: '#444',
  maxWidth: 260,
  whiteSpace: 'pre-line',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginBottom: 4,
};

const MSG_ITEM_DATE_STYLE = {
  fontSize: 12,
  color: '#444',
  marginTop: 2,
};

const MSG_DROPDOWN_HEADER_STYLE = {
  fontWeight: 'bold',
  marginBottom: 8,
  color: '#222',
  fontSize: 15,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
};

const MSG_DROPDOWN_MARK_ALL_READ_BUTTON_STYLE = {
  border: 0,
  background: 'transparent',
  color: '#007BFF',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: 12,
  padding: 0,
};

const Index = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { drawerType, locale, themeColor, darkTheme } = useSelector(
    ({ settings }) => settings
  );
  const [searchBox, setSearchBox] = useState(false);
  const [apps, setApps] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [menuTipo, setmenuTipo] = useState(true);
  const [unreadMessages, setUnreadMessages] = useState([]);
  const [openMsgDropdown, setOpenMsgDropdown] = useState(false);
  const [openDialogDetalhes, setOpenDialogDetalhes] = useState(false);
  const [mensagemSelecionada, setMensagemSelecionada] = useState(null);
  const [hoveredMsgId, setHoveredMsgId] = useState(null);

  const authUserInfo = useSelector(({ auth }) => auth.authUserInfo);

  const carregarMensagensNaoLidas = useCallback(async () => {
    if (!authUserInfo?.id) {
      setUnreadMessages([]);
      return;
    }

    try {
      const response = await api.get('/listar_mensagens', {
        params: {
          tipo: 'Recebidos',
          destinatarioId: authUserInfo.ac_login,
        },
      });
      const onlyUnread = (response.data || []).filter((m) => m.lido === 'Não');
      setUnreadMessages(onlyUnread);
    } catch (error) {
      setUnreadMessages([]);
    }
  }, [authUserInfo?.id, authUserInfo?.ac_login]);

  const getCurrentModule = () => {
    const pathFullMenu = props.location.pathname;
    const pathMenuPos = pathFullMenu.indexOf('/', 6);
    let pathFull = pathFullMenu;
    if (pathMenuPos > 0) pathFull = pathFullMenu.substring(0, pathMenuPos);

    return pathFull;
  };

  const getCurrentModuleColor = () => {
    const currentPath = getCurrentModule();

    const moduleColors = {
      '/app/config': '#ff5722',
      '/app/rel': '#ffa000',
      '/app/dash': '#ffa000',
      '/app/cad': '#00bcd4',
      '/app/backof': '#3f51b5',
      '/app/fin': '#4caf50',
      '/app/com': '#e91e63',
      '/app/cob': '#2196f3',
    };

    return moduleColors[currentPath] || '#2196f3';
  };

  const onSearchBoxSelect = () => {
    setSearchBox(!searchBox);
  };
  const onAppsSelect = () => {
    setApps(!apps);
  };

  const onToggleCollapsedNav = (e) => {
    if (menuTipo === false) {
      setmenuTipo(true);
      setMiniDrawer();
    } else {
      setmenuTipo(false);
      setFixedDrawer();
    }
  };

  const handleDarkTheme = () => {
    dispatch(setDarkTheme());
    const body = document.body.classList;
    body.toggle(themeColor);
    body.toggle('dark-theme');
  };

  const setFixedDrawer = () => {
    dispatch(setDrawerType(FIXED_DRAWER));
  };

  const setMiniDrawer = () => {
    dispatch(setDrawerType(MINI_DRAWER));
  };

  const [unreadChangelogs, setUnreadChangelogs] = useState(0);

  useEffect(() => {
    const existingScript = document.getElementById('featurebase-sdk');
    if (existingScript) {
      existingScript.remove();
    }

    if (window.Featurebase) {
      window.Featurebase('shutdown');
      window.Featurebase = undefined;
    }

    if (
      authUserInfo &&
      (authUserInfo.perfil == 'ADMINISTRADOR' ||
        authUserInfo.perfil == 'LIDER DE EQUIPE')
    ) {
      if (!document.getElementById('featurebase-sdk')) {
        const s = document.createElement('script');
        s.id = 'featurebase-sdk';
        s.src = 'https://do.featurebase.app/js/sdk.js';
        s.async = true;
        s.onload = () => {
          window.Featurebase?.(
            'init_changelog_widget',
            {
              organization: 'cobcloud',
              dropdown: { enabled: true, placement: 'bottom' },
              popup: { enabled: true, autoOpenForNewUpdates: false },
              theme: 'light',
              locale: 'pt-BR',
            },
            (error, data) => {
              if (data?.action === 'unreadChangelogsCountChanged') {
                setUnreadChangelogs(data.unreadCount ?? 0);
              }
            }
          );

          // habilitar IA e base de conhecimento
          /*
          window.Featurebase?.('boot', {
            appId: '689544097f6f9bcc5b828d71', // obrigatório (ID da org, não o nome)
            theme: 'light',
            language: 'pt-BR',
            userId: String(authUserInfo.id_uuid || ''),
            userHash: String(authUserInfo.id_helpdesk || ''),
            name: `${authUserInfo.ac_login} [${authUserInfo.conta_empresa}]`,
          });

          setTimeout(() => {
            const featurebaseElements = document.querySelectorAll(
              '[class*="featurebase"], [data-featurebase], .featurebase-widget'
            );
            featurebaseElements.forEach((element) => {
              element.style.zIndex = '1400';
            });
          }, 1000);
          */
        };
        document.head.appendChild(s);
      }
    }
  }, [authUserInfo]);
  useEffect(() => {
    carregarMensagensNaoLidas();

    const intervalId = setInterval(() => {
      carregarMensagensNaoLidas();
    }, 600000);

    return () => {
      clearInterval(intervalId);
    };
  }, [carregarMensagensNaoLidas]);

  const unreadCount = unreadMessages.filter((m) => m.lido === 'Não').length;
  const marcarComoLido = async (mensagem) => {
    try {
      await api.put(`/marcar_lida_mensagens/${mensagem.id}/lida`);
      setUnreadMessages((prev) =>
        prev.map((m) => (m.id === mensagem.id ? { ...m, lido: 'Sim' } : m))
      );
    } catch (error) {
      enqueueSnackbar('Erro ao marcar mensagem como lida.', {
        variant: 'error',
      });
    }
  };

  const deletarMensagem = async (mensagem) => {
    try {
      await api.delete(`/deletar_mensagens/${mensagem.id}`);
      setUnreadMessages((prev) => prev.filter((m) => m.id !== mensagem.id));
      setOpenDialogDetalhes(false);
      enqueueSnackbar('Mensagem excluída com sucesso!', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Erro ao excluir mensagem.', { variant: 'error' });
    }
  };

  const marcarTodasComoLidas = async () => {
    if (!unreadMessages.length) {
      return;
    }

    try {
      await Promise.all(
        unreadMessages.map((mensagem) =>
          api.put(`/marcar_lida_mensagens/${mensagem.id}/lida`)
        )
      );
      setUnreadMessages([]);
      enqueueSnackbar('Todas as mensagens foram marcadas como lidas.', {
        variant: 'success',
      });
    } catch (error) {
      enqueueSnackbar('Erro ao marcar todas as mensagens como lidas.', {
        variant: 'error',
      });
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target.closest('.msg-dropdown-trigger') &&
        !event.target.closest('.msg-dropdown-menu')
      ) {
        setOpenMsgDropdown(false);
      }
    }
    if (openMsgDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openMsgDropdown]);

  const Apps = () => {
    const moduleColor = getCurrentModuleColor();

    return (
      <div
        className="apps-grid-container"
        style={{ '--module-color': moduleColor }}
      >
        <div className="apps-grid">
          {getControleDeAcesso('rel', authUserInfo) && (
            <div className="app-card">
              <Link className="app-link" to="/app/rel/inicio">
                <div className="app-icon-wrapper">
                  <i className="fa fa-file-text-o app-icon" />
                </div>
                <span className="app-label">Relatórios</span>
              </Link>
            </div>
          )}

          {getControleDeAcesso('comercial', authUserInfo) && (
            <div className="app-card">
              <Link className="app-link" to="/app/com/inicio">
                <div className="app-icon-wrapper">
                  <i className="fa fa-calendar app-icon" />
                </div>
                <span className="app-label">Comercial</span>
              </Link>
            </div>
          )}

          {authUserInfo?.white_label == false &&
            getControleDeAcesso('bi', authUserInfo) && (
              <div className="app-card">
                <a
                  className="app-link"
                  target="_blank"
                  href="https://bi.cob.cloud/"
                >
                  <div className="app-icon-wrapper">
                    <i className="fa fa-bar-chart app-icon" />
                  </div>
                  <span className="app-label">CobCloud BI</span>
                </a>
              </div>
            )}

          {getControleDeAcesso('conf', authUserInfo) && (
            <div className="app-card">
              <Link className="app-link" to="/app/config/inicio">
                <div className="app-icon-wrapper">
                  <i className="fa fa-cogs app-icon" />
                </div>
                <span className="app-label">Configurações</span>
              </Link>
            </div>
          )}

          {getControleDeAcesso('funcionalidade_pro', authUserInfo) && (
            <div className="app-card pro-features">
              <a className="app-link">
                <div className="app-icon-wrapper">
                  <i className="fa fa-star app-icon" />
                </div>
                <span className="app-label">Funcionalidades PRÓ</span>
              </a>
            </div>
          )}
        </div>
      </div>
    );
  };

  const updateSearchText = (e) => {
    setSearchText(e.target.value.trim());
  };

  async function localizarProcesso(processo) {
    let nProcesso = '';
    if (processo == '') nProcesso = searchText;
    else nProcesso = processo;

    if (nProcesso != '') {
      const hashEmpresa = getHashEmpresa();
      const response = await api.get(
        `/localizar_processo/${hashEmpresa}?processo=${nProcesso}`
      );
      const data = await response.data.rows;
      if (data.length > 0) {
        if (data[0].status_credor === 'ATIVO') {
          const uid = data[0].iddev;

          history.push(`/app/cob/processo/${uid}`, { id: uid });
        } else if (data[0].status_credor === 'INATIVO') {
          enqueueSnackbar('Atenção. Processo de Credor INATIVO!', {
            variant: 'warning',
          });
        }
      } else {
        enqueueSnackbar('Atenção. Processo não Localizado!', {
          variant: 'warning',
        });
      }
    }
  }

  const drawerStyle = drawerType.includes(FIXED_DRAWER)
    ? 'd-block d-xl-none'
    : drawerType.includes(COLLAPSED_DRAWER)
    ? 'd-block'
    : 'd-none';

  const parseDateTime = (data, hora = '00:00') => {
    const date = new Date(data);

    const [h, m] = hora.split(':');

    date.setHours(Number(h));
    date.setMinutes(Number(m));
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  };

  const moduloLinks = [
    {
      key: 'cob',
      enabled: true,
      title: 'Cobrança',
      to: '/app/cob/inicio',
      icon: <HeadsetMic style={{ color: '#fff' }} />,
    },
    {
      key: 'cad',
      enabled: getControleDeAcesso('cad', authUserInfo),
      title: 'Cadastros',
      to: '/app/cad/inicio',
      icon: <FolderShared style={{ color: '#fff' }} />,
    },
    {
      key: 'fin',
      enabled: getControleDeAcesso('fin', authUserInfo),
      title: 'Financeiro',
      to: '/app/fin/inicio',
      icon: <AttachMoney style={{ color: '#fff' }} />,
    },
    {
      key: 'back',
      enabled: getControleDeAcesso('back', authUserInfo),
      title: 'BackOffice',
      to: '/app/backof/inicio',
      icon: <SupervisedUserCircle style={{ color: '#fff' }} />,
    },
    {
      key: 'dash',
      enabled: getControleDeAcesso('dash', authUserInfo),
      title: 'Dashboards',
      to: '/app/dash/inicio',
      icon: <AssessmentIcon style={{ color: '#fff' }} />,
    },
  ].filter((item) => item.enabled);

  const ehNegociadorComSomenteCobranca =
    authUserInfo?.perfil === 'NEGOCIADOR' && moduloLinks.length === 1;

  return (
    <AppBar className="app-main-header">
      <Toolbar className="app-toolbar" disableGutters={false}>
        <IconButton
          className="jr-menu-icon mr-3 d-block"
          aria-label="Menu"
          onClick={onToggleCollapsedNav}
        >
          <span className="menu-icon" />
        </IconButton>
        <SearchBox
          styleName="d-none d-lg-block ml-0 mr-3"
          placeholder2="LOCALIZAR PROCESSO"
          onChange={updateSearchText}
          onClick={() => localizarProcesso('')}
          onKeyPress={(ev) => {
            if (ev.key == 'Enter') {
              localizarProcesso(ev.target.value);
            }
          }}
          value={searchText}
        />
        <ul className="header-notifications list-inline ml-auto">
          <li
            className="list-inline-item"
            style={
              ehNegociadorComSomenteCobranca ? { marginRight: 0 } : undefined
            }
          >
            {moduloLinks.map((item) => (
              <Tooltip key={item.key} title={item.title} arrow>
                <Link
                  className="jr-list-link"
                  to={item.to}
                  style={
                    ehNegociadorComSomenteCobranca
                      ? { padding: '6px 0 6px 6px' }
                      : moduloLinks.length === 1
                      ? { padding: '6px 4px 6px 8px' }
                      : undefined
                  }
                >
                  <IconButton className="icon-btn">{item.icon}</IconButton>
                </Link>
              </Tooltip>
            ))}
          </li>

          {authUserInfo &&
            authUserInfo.perfil !== 'NEGOCIADOR' &&
            !authUserInfo.unificar_grupo && (
              <li className="list-inline-item">
                <Dropdown
                  className="quick-menu app-notification"
                  isOpen={apps}
                  toggle={onAppsSelect}
                >
                  <DropdownToggle
                    className="d-inline-block"
                    tag="span"
                    data-toggle="dropdown"
                  >
                    <span className="app-notification-menu pt-1 pb-1">
                      <i className="zmdi zmdi-apps zmdi-hc-fw zmdi-hc-lg" />
                      <span>Apps</span>
                    </span>
                  </DropdownToggle>

                  <DropdownMenu>{Apps()}</DropdownMenu>
                </Dropdown>
              </li>
            )}

          <li
            className="list-inline-item"
            style={{
              position: 'relative',
              marginLeft: ehNegociadorComSomenteCobranca
                ? -10
                : moduloLinks.length === 1
                ? -6
                : 0,
            }}
          >
            <Badge
              color="error"
              overlap="circular"
              badgeContent={unreadCount}
              invisible={unreadCount === 0}
              max={99}
            >
              <IconButton
                className="icon-btn msg-dropdown-trigger"
                onClick={async () => {
                  await carregarMensagensNaoLidas();
                  setOpenMsgDropdown((prev) => !prev);
                }}
              >
                <MessageIcon style={{ fontSize: 22, color: '#fff' }} />
              </IconButton>
            </Badge>

            {openMsgDropdown && (
              <div
                className="msg-dropdown-menu open"
                style={MSG_DROPDOWN_MENU_STYLE}
              >
                <div style={MSG_DROPDOWN_HEADER_STYLE}>
                  {unreadCount > 0 && (
                    <>
                      <span>Mensagens não lidas</span>
                      <button
                        type="button"
                        onClick={async (e) => {
                          e.stopPropagation();
                          await marcarTodasComoLidas();
                        }}
                        style={MSG_DROPDOWN_MARK_ALL_READ_BUTTON_STYLE}
                      >
                        Marcar todas como lidas
                      </button>
                    </>
                  )}
                </div>
                {unreadCount === 0 ? (
                  <div
                    style={{ padding: 12, color: '#888', textAlign: 'center' }}
                  >
                    Nenhuma mensagem nova
                  </div>
                ) : (
                  unreadMessages
                    .filter((m) => m.lido === 'Não')
                    .sort((a, b) => {
                      return (
                        parseDateTime(b.data, b.hora) -
                        parseDateTime(a.data, a.hora)
                      );
                    })
                    .map((msg) => {
                      const maxLen = 80;
                      const assuntoPreview =
                        msg.assunto && msg.assunto.length > 36
                          ? msg.assunto.substring(0, 36) + '...'
                          : msg.assunto;
                      const bodyPreview =
                        msg.obs && msg.obs.length > maxLen
                          ? msg.obs.substring(0, maxLen) + '...'
                          : msg.obs;
                      return (
                        <div
                          key={msg.id}
                          onClick={() => {
                            setMensagemSelecionada(msg);
                            setOpenDialogDetalhes(true);
                            setOpenMsgDropdown(false);
                          }}
                          onMouseEnter={() => setHoveredMsgId(msg.id)}
                          onMouseLeave={() => setHoveredMsgId(null)}
                          style={{
                            ...MSG_DROPDOWN_ITEM_STYLE,
                            ...(hoveredMsgId === msg.id
                              ? MSG_DROPDOWN_ITEM_HOVER_STYLE
                              : null),
                          }}
                        >
                          <div style={MSG_ITEM_DE_STYLE}>
                            <b>De:</b>{' '}
                            <span style={{ color: '#007BFF' }}>
                              {msg.sender_name}
                            </span>
                          </div>
                          <div style={MSG_ITEM_SUBJECT_STYLE}>
                            <b>Assunto:</b>{' '}
                            <span style={{ color: '#444' }}>
                              {assuntoPreview}
                            </span>
                          </div>
                          <div style={MSG_ITEM_BODY_STYLE}>
                            <b>Mensagem:</b>{' '}
                            <span style={{ color: '#555' }}>{bodyPreview}</span>
                          </div>
                          <div style={MSG_ITEM_DATE_STYLE}>
                            <b>Data:</b>{' '}
                            <span style={{ color: '#555' }}>
                              {msg.data
                                ? new Date(msg.data).toLocaleDateString('pt-BR')
                                : ''}{' '}
                              - {msg.hora || '00:00'}
                            </span>
                          </div>
                        </div>
                      );
                    })
                )}
              </div>
            )}

            {authUserInfo &&
              (authUserInfo.perfil == 'ADMINISTRADOR' ||
                authUserInfo.perfil == 'LIDER DE EQUIPE') && (
                <Badge
                  color="error"
                  overlap="circular"
                  badgeContent={unreadChangelogs}
                  invisible={unreadChangelogs === 0}
                  max={99}
                >
                  <IconButton className="icon-btn" data-featurebase-changelog>
                    <CampaignIcon style={{ color: '#fff' }} />
                  </IconButton>
                </Badge>
              )}

            <IconButton
              className="icon-btn"
              onClick={() => {
                dispatch(userSignOut());
              }}
            >
              <ExitToApp style={{ color: '#fff' }} />
            </IconButton>
          </li>
        </ul>{' '}
        <div className="ellipse-shape" />
      </Toolbar>

      <DialogDetalhesMensagem
        open={openDialogDetalhes}
        onClose={() => setOpenDialogDetalhes(false)}
        mensagem={mensagemSelecionada}
        tab="RECEBIDOS"
        onMarcarComoLido={marcarComoLido}
        showMarcarComoLido={true}
        onDeletarMensagem={deletarMensagem}
        showDeletarMensagem={true}
      />
    </AppBar>
  );
};

export default withRouter(Index);
